export default __webpack_public_path__ + "static/media/qr.943e9b33.svg";